import { createSelector } from 'reselect';
import getParams from 'app/common/lib/params';
import { EXT_ELJUR } from 'app/common/constants/services';


const eljurToken = createSelector(
  state => state.user.tokens,
  tokens => (tokens[Object.keys(tokens).find(key => (
    tokens[key].service === EXT_ELJUR
  ))] || {})
);

const selectTokenData = createSelector(
  [
    getParams,
    eljurToken,
  ],
  (params, tokens) => ({
    token: params.auth_token || tokens.token,
    vendor: params.vendor || tokens.vendor,
    isSaved:
      tokens.token
      && tokens.vendor
      && (params.auth_token ? tokens.token === params.auth_token : true)
      && (params.vendor ? tokens.vendor === params.vendor : true),
  })
);

export default selectTokenData;
